// eslint-disable-next-line
import styles from './navigationBar.css';
import logo_horizontal from './../../../logo_horizontal.png';
import { Link, useNavigate } from 'react-router-dom';

function NavigationBar() {
    function openSidebar(button) {
        const navbar = document.getElementById('navbar')
        navbar.classList.add('show')
        // button.target.setAttribute('aria-expanded', 'true')
        // navbar.removeAttribute('inert')
    }
        
    function closeSidebar(button) {
        const navbar = document.getElementById('navbar')
        navbar.classList.remove('show')
        // button.target.setAttribute('aria-expanded', 'false')
        // navbar.setAttribute('inert', '')
    }

 return (
    <>
    <a href="/"><img src={logo_horizontal} className="logoCircle" alt="logo" /></a>

    <button id="open-sidebar-button" onClick={openSidebar} aria-label="open sidebar" aria-expanded="false" aria-controls="navbar">
      <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#64a9ff"><path d="M165.13-254.62q-10.68 0-17.9-7.26-7.23-7.26-7.23-18t7.23-17.86q7.22-7.13 17.9-7.13h629.74q10.68 0 17.9 7.26 7.23 7.26 7.23 18t-7.23 17.87q-7.22 7.12-17.9 7.12H165.13Zm0-200.25q-10.68 0-17.9-7.27-7.23-7.26-7.23-17.99 0-10.74 7.23-17.87 7.22-7.13 17.9-7.13h629.74q10.68 0 17.9 7.27 7.23 7.26 7.23 17.99 0 10.74-7.23 17.87-7.22 7.13-17.9 7.13H165.13Zm0-200.26q-10.68 0-17.9-7.26-7.23-7.26-7.23-18t7.23-17.87q7.22-7.12 17.9-7.12h629.74q10.68 0 17.9 7.26 7.23 7.26 7.23 18t-7.23 17.86q-7.22 7.13-17.9 7.13H165.13Z"/></svg>
    </button>

    <nav id="navbar">
    <ul>
      <li>
        <button id="close-sidebar-button" onClick={closeSidebar} aria-label="close sidebar">
          <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#64a9ff">
            <path
              d="m480-444.62-209.69 209.7q-7.23 7.23-17.5 7.42-10.27.19-17.89-7.42-7.61-7.62-7.61-17.7 0-10.07 7.61-17.69L444.62-480l-209.7-209.69q-7.23-7.23-7.42-17.5-.19-10.27 7.42-17.89 7.62-7.61 17.7-7.61 10.07 0 17.69 7.61L480-515.38l209.69-209.7q7.23-7.23 17.5-7.42 10.27-.19 17.89 7.42 7.61 7.62 7.61 17.7 0 10.07-7.61 17.69L515.38-480l209.7 209.69q7.23 7.23 7.42 17.5.19 10.27-7.42 17.89-7.62 7.61-17.7 7.61-10.07 0-17.69-7.61L480-444.62Z" />
          </svg>
        </button>
      </li>
      <li className="home-li"><img src={logo_horizontal} className="logoCircle2" alt="logo" /></li>
      <li><a href="/#about-section" onClick={closeSidebar}>O nas</a></li>
      <li><a href="/#trips-section" onClick={closeSidebar}>Wycieczki</a></li>  
      <li><a href="/#safaris-section" onClick={closeSidebar}>Safari</a></li>
      <li><a href="/#contact-section" onClick={closeSidebar}>Kontakt</a></li>
    </ul>
  </nav>

  <div id="overlay" onClick={closeSidebar} aria-hidden="true"></div>
  </>
  );
}

export default NavigationBar;